import React, { useState, useEffect } from "react";
import Category from "../../../../APIController/Category";
import { useModal } from "../../../../Components/Modal";
import CategoryForm from "../Forms/CategoryForm";
import Text from "../../../../Components/Text";
import CrudPage from "../../../../Components/CrudPage";

function CategoryManagement() {
    /* Get functions and variables from Controller */
    const {
        fetchCategories,
        fetchInactivCategories,
        deleteCategory,
        reactivateCategory,
        permaDeleteCategory } = Category();

    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()

    /* Category collections */
    const [categories, setCategories] = useState([]);

    const [searchActive, setSearchActive] = useState(true)

    /* async fetching  */
    useEffect(() => {
        fetchData();
    }, [searchActive]);

    /* Switch between active Inactive */
    const fetchData = async () => {
        const data = searchActive ? await fetchCategories() : await fetchInactivCategories();
        setCategories(data)
    };

    /* CRUD Handler */
    const handleDeleteCategory = async (e, category) => {
        await deleteCategory(category.id);
        fetchData(); // Daten neu laden
    };

    const handleReactivateCategory = async (e, category) => {
        await reactivateCategory(category.id);
        fetchData();
    };

    const handlePermaDeleteCategory = async (e, category) => {
        await permaDeleteCategory(category.id);
        fetchData(); // Daten neu laden
    };

    const formActions = () => {
        fetchData()
        closeModal()
    }

    /* Edit Button click handler */
    const handleEditClick = (e, category) => {
        e.preventDefault();
        openModal(<CategoryForm
            selectedCategory={category}
            afterAction={formActions}
        />)
    }

    /* Add Button Click helper */
    const handleAddClick = (e) => {
        e.preventDefault();
        openModal(<CategoryForm
            afterAction={formActions}
        />)
    }

    const crudActions = [
        { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
        searchActive &&{ type: "create", color: "bg-white", action: handleAddClick },
        searchActive
            ? { type: "delete", color: "red", action: handleDeleteCategory, icon: "archive" }
            : { type: "permadelete", color: "red", action: handlePermaDeleteCategory, icon: "trash" },
        !searchActive && { type: "reactivate", color: "black", action: handleReactivateCategory, icon: "restore" },
        
    ].filter(Boolean);

    const MainView = () => (
        <>
            <CrudPage
                title={"Kategorien"}
                items={categories}
                displayMethod={(category) => (
                    <Text type="itemtext" classNames="flex-1 break-words overflow-hidden text-ellipsis">{category.name}</Text>
                )}
                crudActions={crudActions}
                toggleButtonOptions={[
                    {
                        text: "Aktiv",
                        onClickAction: () => setSearchActive(true),
                    },
                    {
                        text: "Inaktiv",
                        onClickAction: () => setSearchActive(false),
                    },
                ]}
                allowedTarget={"categoriesCount"}
                currentTargetValue={categories.length}
            />
            <ModalView classNames="w-auto" />
        </>
    )

    return (MainView())
}
export default CategoryManagement;